import React from 'react';
import './footer.css';
import { VerticalSeparator } from '../components/separators';
import { ReactComponent as GeoIcon } from '../icons/geo.svg'
import { ReactComponent as PhoneIcon } from '../icons/telephone.svg'
import { ReactComponent as MailIcon } from '../icons/mail.svg'

const Footer = () => {

  return (
    <>
      <footer className="footer" style={{ alignItems: 'center' }}>
        <VerticalSeparator height={"1.2vw"}></VerticalSeparator>
        <div className="icons-container row">
          {/* Icona + Mail */}
          <div className="col-sm-12 mb-2">
            <div className="footer-icon">
              <MailIcon style={{ width: '20px', height: '20px' }} />
              <span className="ms-2">vacanzasantabarbara@gmail.com</span>
            </div>
          </div>
          {/* Icona + Telefono */}
          <div className="col-sm-12 mb-2">
            <div className="footer-icon">
              <PhoneIcon style={{ width: '20px', height: '20px' }} />
              <span className="ms-2">+39 3337813274</span>
            </div>
          </div>
          {/* Icona + Luogo */}
          <div className="col-sm-12 mb-2">
            <div className="footer-icon">
              <GeoIcon style={{ width: '20px', height: '20px' }} />
              <span className="ms-2">Via Milano 8, Marina di Ragusa, RG</span>
            </div>
          </div>
        </div>
        <p className="mb-2 col-12 text-center">CIN: IT088009C2SQ9KFK98</p>
        <p className="mb-2 col-12 text-center">© 2024 Casa Santa Barbara</p>
      </footer>
    </>
  );
}

export default Footer;
